import { useContext } from "react";
import { MdArrowBack, MdArrowForward } from "react-icons/md";
import { AppContext } from "../App";
import PageHero from "./PageHero";
import { getProjectBySlug, projects } from "./ProjectsContent";

export default function OneProject(props) {
  const { projectSlug } = props;
  const appContext = useContext(AppContext);
  const project = getProjectBySlug(projectSlug) || projects[0];

  const details = [
    { label: "Status", value: project.status },
    { label: "Client", value: project.client },
    { label: "Location", value: project.location },
    { label: "Value", value: project.value },
    { label: "Category", value: project.category },
  ];

  return (
    <>
      <PageHero
        eyebrow="Project"
        title={project.name}
        text={project.description}
        image={project.image}
      />

      <section className="tgm-section tgm-project-detail" data-aos="fade-up">
        <div className="container">
          <button
            type="button"
            className="tgm-project-back"
            onClick={() => appContext.navTo({ item: "projects" })}
          >
            <MdArrowBack /> Back to projects
          </button>

          <div className="tgm-project-detail-layout">
            <div className="tgm-project-detail-copy">
              <p className="tgm-section-kicker">Project Overview</p>
              <h2>{project.category}</h2>
              <p>{project.description}</p>

              <div className="tgm-project-detail-grid">
                {details.map((detail) => (
                  <div className="tgm-project-detail-stat" key={detail.label}>
                    <span>{detail.label}</span>
                    <strong>{detail.value}</strong>
                  </div>
                ))}
              </div>
            </div>

            <div className="tgm-project-detail-feature">
              <img src={project.image} alt={project.name} />
            </div>
          </div>

          <div className="tgm-project-gallery">
            <div className="tgm-section-head">
              <div>
                <p className="tgm-section-kicker">Project Images</p>
              </div>
            </div>

            <div className="tgm-project-gallery-grid">
              {project.images.map((image, index) => (
                <figure className="tgm-project-gallery-item" key={`${project.slug}-${index}`}>
                  <img src={image} alt={`${project.name} ${index + 1}`} />
                </figure>
              ))}
            </div>
          </div>

          <div className="tgm-project-next">
            <div>
              <span>Need a similar project handled?</span>
              <strong>Talk to SMART TGM Limited about your scope.</strong>
            </div>
            <button
              type="button"
              className="tgm-solid-btn"
              onClick={() => appContext.navTo({ item: "contact_us" })}
            >
              Contact us <MdArrowForward />
            </button>
          </div>
        </div>
      </section>
    </>
  );
}
